import React from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsMap from "highcharts/modules/map";
import {texasChartOptions, texasRegionsChartOptions} from './chartOptions';
import {executeQuery} from "../../requests/executeQuery";
import arrowGreen from '../../svgs/arrow-green.svg';
import arrowRed from '../../svgs/arrow-red.svg';
import MapChart from "../UsMapChart/UsMapChart";
import shallowequal from "shallowequal";
import filter from "../../filter";
import {addCommasToNumberAsString, renderPrintFooter} from "../../utils";
import {TEXAS_TOTAL_TRANSACTIONS, TEXAS_REGION_TRANSACTIONS, BUYERS_LOCATION, BUYERS_LOCATION_TOTAL} from '../../consts/queries';
import {browserHistory} from "react-router";

highchartsMap(Highcharts);
const find = require('lodash.find');
const cloneDeep = require('lodash.clonedeep');

export default class TransactionBreakdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            query: {},
            texasTotalChartOptions: cloneDeep(texasChartOptions),
            texasRegChartOptions: cloneDeep(texasRegionsChartOptions),
            year: null,
            previousYear: null,
            previousYearTotal: 0,
            regionTransactions: [],
            buyersLocationData: [],
            buyersLocationTotal: 0,
            isPrint: false,
            printBackground: '',
        };

        this.beforePrint = this.beforePrint.bind(this);
        this.afterPrint = this.afterPrint.bind(this);
    }

    componentDidMount() {
        this.setState({printBackground: `url('${arc.path.media+'Transaction_Background.png'}')`}, () => this.fetch(this.props.location.query));
        window.history.replaceState(null, '');
        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;
    }

    componentDidUpdate(prevProps) {
        if (!shallowequal(prevProps.location.query, this.props.location.query)) {
            this.fetch(this.props.location.query);
        }
    }

    beforePrint() {
        this.setState({isPrint: true});
    }

    afterPrint() {
        this.setState({isPrint: false});
    }

    fetch(q) {
        const query = {...q};
        const queryPrevYear = {...q};

        const today = new Date();
        let year = today.getFullYear().toString(), prevYear = year - 1;
        if (query.TRANSACTION_YEAR) {
            year = query.TRANSACTION_YEAR;
            prevYear = (year - 1).toString();
            queryPrevYear.TRANSACTION_YEAR = prevYear;
        } else {
            year = '';
            prevYear = '';
        }

        const options = filter(query, 'transaction-breakdown');
        const optionsPrevYear = filter(queryPrevYear, 'transaction-breakdown');

        const requests = [
            executeQuery({queryName: TEXAS_TOTAL_TRANSACTIONS, options}),
            executeQuery({queryName: TEXAS_TOTAL_TRANSACTIONS, options: optionsPrevYear}),
            executeQuery({queryName: TEXAS_REGION_TRANSACTIONS, options}),
            executeQuery({queryName: TEXAS_REGION_TRANSACTIONS, options: optionsPrevYear}),
            executeQuery({queryName: BUYERS_LOCATION, options}),
            executeQuery({queryName: BUYERS_LOCATION_TOTAL, options}),
        ];

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].data && Array.isArray(res[0].data) &&
                res[1] && res[1].data && Array.isArray(res[1].data) &&
                res[2] && res[2].data && Array.isArray(res[2].data) &&
                res[3] && res[3].data && Array.isArray(res[3].data) &&
                res[4] && res[4].data && Array.isArray(res[4].data) &&
                res[5] && res[5].data && Array.isArray(res[5].data)) {

                const regionTransactions = [];
                let texasRegChartData;
                if (!this.state.texasRegChartOptions.series) texasRegChartData = cloneDeep(texasRegionsChartOptions.series[0].data);
                else texasRegChartData = cloneDeep(this.state.texasRegChartOptions.series[0].data);
                texasRegChartData.map(region => {
                    const foundRegion = find(res[2].data, {MARKET: region.name});
                    const foundRegionPrevYear = find(res[3].data, {MARKET: region.name});
                    region.value = foundRegion ? Number(foundRegion.COUNT) : 0;
                    const q = cloneDeep(query);
                    delete q.TRANSACTION_YEAR;
                    const today = new Date();
                    const month = today.getMonth() + 1;
                    const day = today.getDate();
                    region.events.click = () => browserHistory.push({
                        pathname: '/list',
                        query: {
                            CLOSE_OF_ESCROW_MIN: `01/01/${query.TRANSACTION_YEAR}`,
                            CLOSE_OF_ESCROW_MAX: `${month < 10 ? `0${month}` : month}/${day < 10 ? `0${day}` : day}/${query.TRANSACTION_YEAR}`,
                            MARKET: region.name,
                            ...q,
                        }
                    })
                    regionTransactions.push({
                        MARKET: region.name,
                        COUNT: foundRegion ? Number(foundRegion.COUNT) : 0,
                        COUNT_PREV_YEAR: foundRegionPrevYear ? Number(foundRegionPrevYear.COUNT) : 0,
                    });
                });

                this.setState({
                    query,
                    year: year,
                    previousYear: prevYear,
                    texasTotalChartOptions: {
                        series: [{
                            data: [{
                                id: 'id0',
                                y: 0,
                                value: Number(res[0].data[0].COUNT),
                                color: '#6D9FCE',
                            }]
                        }]
                    },
                    previousYearTotal: res[1].data[0].COUNT,
                    texasRegChartOptions: {
                        series: [{
                            data: texasRegChartData,
                            dataLabels: {
                                formatter: function() {
                                    const percent = parseFloat(res[0].data[0].COUNT) ? (this.point.value / res[0].data[0].COUNT * 100).toFixed(2) : '0.00';
                                    let className = 'chart-data-label';
                                    switch (this.point.name) {
                                        case 'WEST TEXAS':
                                            className += ' west';
                                            break;
                                        case 'DFW':
                                        case 'CENTRAL':
                                            className += ' margin-bottom';
                                            break;
                                    }
                                    return `<div class="${className}">${this.point.name}<span class="chart-data-label-format">${this.point.value} (${percent}%)</span></div>`;
                                }
                            }
                        }]
                    },
                    regionTransactions: regionTransactions,
                    buyersLocationData: res[4].data,
                    buyersLocationTotal: Number(res[5].data[0].TOTAL_PROPERTIES) || 0,
                });
                return;
            }
            this.setState({
                query,
                year: year,
                previousYear: prevYear,
            });
        });
    }

    static renderTexasTotal({texasTotalChartOptions, tenantType, year, previousYear, previousYearTotal, query}) {
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonth = today.getMonth() + 1;
        const currentDay = today.getDate();
        const startSaleDate = year ? `1/1/${year}` : '';
        const endSaleDate = year ? (year === currentYear ? `${currentMonth}/${currentDay}/${year}` : `12/31/${year}`) : '';
        const type = tenantType ? (tenantType === 'MT' ? 'Multi-Tenant' : 'Single-Tenant') : '';
        const category = query.CATEGORY ? (query.CATEGORY[0].toUpperCase() + query.CATEGORY.slice(1)) : '';
        let sqft = '';
        let salePrice = '';

        if (tenantType === 'MT') {
            if (query.SQFT_MIN && query.SQFT_MAX) {
                sqft = `${addCommasToNumberAsString(query.SQFT_MIN)} - ${addCommasToNumberAsString(query.SQFT_MAX)}`;
            } else if (query.SQFT_MIN) {
                sqft = `${addCommasToNumberAsString(query.SQFT_MIN)}+`;
            } else if (query.SQFT_MAX) {
                sqft = `0 - ${addCommasToNumberAsString(query.SQFT_MAX)}`;
            }

            if (query.SOLD_PRICE_MIN && query.SOLD_PRICE_MAX) {
                salePrice = `$${addCommasToNumberAsString(query.SOLD_PRICE_MIN)} - $${addCommasToNumberAsString(query.SOLD_PRICE_MAX)}`;
            } else if (query.SOLD_PRICE_MIN) {
                salePrice = `$${addCommasToNumberAsString(query.SOLD_PRICE_MIN)}+`;
            } else if (query.SOLD_PRICE_MAX) {
                salePrice = `$0 - $${addCommasToNumberAsString(query.SOLD_PRICE_MAX)}`;
            }
        }

        return (
            <div className='texas-total'>
                <div className='chart-title'>{tenantType} Transactions - {year}</div>
                <div className='chart-subtitle'>IN TEXAS</div>
                <HighchartsReact
                    highcharts={Highcharts}
                    constructorType={'mapChart'}
                    options={texasTotalChartOptions}
                />
                <div className='texas-total-criteria'>
                    <div className='criteria-title'>Criteria:</div>
                    <ul className='texas-criteria-list'>
                        <li className='texas-criteria-item'>{type} {category} in Texas</li>
                        <li className='texas-criteria-item'>Sale Date: {startSaleDate} - {endSaleDate}</li>
                        {
                            tenantType === 'MT' ?
                                <React.Fragment>
                                    {
                                        sqft && <li className='texas-criteria-item'>Size: {sqft} sq ft</li>
                                    }
                                    {
                                        salePrice && <li className='texas-criteria-item'>Sale Price: {salePrice}</li>
                                    }
                                    <li className='texas-criteria-item'>Exclude Bulk Portfolio Sales</li>
                                </React.Fragment>
                                :
                                <li className='texas-criteria-item'>Investment Properties</li>
                        }
                        <li className='texas-criteria-item'>In {previousYear} there were {previousYearTotal} trades</li>
                    </ul>
                </div>
            </div>
        )
    }

    static renderTexasPerRegionTable({regionTransactions, previousYear, year}) {
        return (
            <table className='texas-regions-table'>
                <thead>
                <tr className='texas-regions-tr'>
                    <th className='texas-regions-th'/>
                    <th className='texas-regions-th'>{previousYear}</th>
                    <th className='texas-regions-th'>{year}</th>
                    <th className='texas-regions-th'>Delta</th>
                </tr>
                </thead>
                <tbody>
                {
                    regionTransactions.map((region, index) => {
                        const total = region.COUNT ? region.COUNT : 0;
                        const totalPrevYear = region.COUNT_PREV_YEAR ? region.COUNT_PREV_YEAR : 0;
                        let delta = totalPrevYear ? ((total - totalPrevYear) / totalPrevYear * 100).toFixed(1) : (total * 100).toFixed(1);
                        const negative = delta < 0;
                        if (delta < 0) {
                            delta = Math.abs(delta);
                        }
                        return (
                            <tr key={index} className='texas-regions-tr'>
                                <td className={`texas-regions-td ${index % 2 === 0 ? 'second-color' : ''}`}>{region.MARKET}</td>
                                <td className={`texas-regions-td ${index % 2 === 0 ? 'second-color' : ''}`}>{totalPrevYear}</td>
                                <td className={`texas-regions-td ${index % 2 === 0 ? 'second-color' : ''}`}>{total}</td>
                                <td className={`texas-regions-td ${index % 2 === 0 ? 'second-color' : ''}`}>
                                    <div className='texas-regions-delta'>
                                        {delta}%
                                        <div className={negative ? 'arrow-red' : 'arrow-green'} dangerouslySetInnerHTML={{__html: negative ? arrowRed : arrowGreen}}/>
                                    </div>
                                </td>
                            </tr>
                        )
                    })
                }
                </tbody>
            </table>
        )
    }

    static renderTexasPerRegion({texasRegChartOptions, texasRegChartData, regionTransactions, previousYear, year, queryType}) {
        return (
            <div className='texas-regions'>
                <div className='texas-regions-legend'>
                    {
                        texasRegChartData.map(region => {
                            return (
                                <div key={region.id} className='texas-regions-legend-row'>
                                    <div className='texas-regions-legend-color' style={{backgroundColor: region.color}}/>
                                    {region.name.toUpperCase()}
                                </div>
                            )
                        })
                    }
                </div>
                <div className='chart-title region'>Transactions Per Region</div>
                <div className='chart-subtitle region'>{queryType}</div>
                <HighchartsReact
                    highcharts={Highcharts}
                    constructorType={'mapChart'}
                    options={texasRegChartOptions}
                />
                {TransactionBreakdown.renderTexasPerRegionTable({regionTransactions, previousYear, year})}
            </div>
        )
    }

    static renderBuyerLocation({buyersLocationData, buyersLocationTotal, queryType}) {
        return (
            <div className='us-chart'>
                <div className='chart-title buyer'>Buyers' Location</div>
                <div className='chart-subtitle buyer'>{queryType}</div>
                <div className='us-chart-map-container'>
                    <MapChart data={buyersLocationData} total={buyersLocationTotal}/>
                </div>
            </div>
        )
    }

    render() {
        const {query, texasTotalChartOptions, texasRegChartOptions, year, previousYear, previousYearTotal,
            regionTransactions, buyersLocationData, buyersLocationTotal, isPrint, printBackground} = this.state;
        const texasRegChartData = texasRegChartOptions.series ? texasRegChartOptions.series[0].data : [];

        return (
            <div className='TransactionBreakdown'>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {TransactionBreakdown.renderTexasTotal({texasTotalChartOptions, tenantType: query.TYPE, year, previousYear, previousYearTotal, query})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {TransactionBreakdown.renderTexasPerRegion({texasRegChartOptions, texasRegChartData, regionTransactions, previousYear, year, queryType: query.TYPE})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='print-container' style={{backgroundImage: isPrint && printBackground}}>
                    {TransactionBreakdown.renderBuyerLocation({buyersLocationData, buyersLocationTotal, queryType: query.TYPE})}
                    {renderPrintFooter(isPrint)}
                </div>
                <div className='preload-print-background' style={{backgroundImage: printBackground}}/>
            </div>
        )
    }
}